export default {"src":"/_next/static/media/ApplePay.6a604abe.svg","height":36,"width":53,"blurWidth":0,"blurHeight":0};